import { render, staticRenderFns } from "./DFInputNumber.vue?vue&type=template&id=5ff532dc&"
import script from "./DFInputNumber.vue?vue&type=script&lang=js&"
export * from "./DFInputNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports